import React from 'react'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { browserHistory } from 'react-router';

import { tenants } from '../../core/controllers/tenants';

export default class LatePaymentsList extends React.Component {
    constructor(props) {
        super(props);


        this.mobileTarget =
            window.matchMedia(
                "(min-width: 700px)"
            ); /* Retain the target so the event listener can be 
            unmounted */
        this.hideTasksListener = (event) => {
            // Define the event lister
            if (event.matches) {
                // Window has gone from desktop to mobile view
                this.setState({
                    mobileView: true,
                });
            } else {
                // mobile to desktop
                this.setState({
                    mobileView: false,
                });
            }
        
        };
        this.mobileTarget.addEventListener("change", this.hideTasksListener);
        this.state = {
            tenantsData: null,
            mobileView: this.mobileTarget.matches,
        };

        this.index = 0;
    }

    componentWillUnmount() {
        this.mobileTarget.removeEventListener("change", this.hideTasksListener) 
    }

    componentDidMount() {
        var self = this;
        tenants.getTenants('late', function(response){
            if (response.data.length > 0) {
                self.setState({tenantsData: response.data});
            }
        });
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    flattenObject(ob, tenantName) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        toReturn["tenant_name"] = tenantName;
        return toReturn;
    }

    didSelectRow(row) {
        browserHistory.push('/tenant/' + row.tenant_id);
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    render(){
        var self = this;
        var tenantsData = this.state.tenantsData;
        var mobileView = this.state.mobileView;


        if (tenantsData != null) {
            tenantsData = tenantsData.map(function(tenant) {
                if (tenant.data != null) {
                    var tenantName = "";
                    tenantName += tenant.data.tenant_firstname + " " + tenant.data.tenant_lastname;
                }
                return self.flattenObject(tenant, tenantName);
            });
        }

        const options = {
            onRowClick: this.didSelectRow
        };

        return (
            <div class="row">
                <div class="content">
                {tenantsData != null ? (
                    <BootstrapTable data={tenantsData} version='4' striped search pagination hover options={options}>
                        <TableHeaderColumn dataField='tenant_id'  width="50" hidden={!mobileView} dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={true}></TableHeaderColumn>
                        <TableHeaderColumn dataField='tenant_name' dataSort={ true }>Name</TableHeaderColumn>
                        <TableHeaderColumn dataField='tenant_email' dataSort={ true }>Email</TableHeaderColumn>
                        {/* <TableHeaderColumn dataField='tenant_late_rent' dataSort={ true }>Amount</TableHeaderColumn> */}
                        {/* <TableHeaderColumn dataField='' dataSort={ true }>Due Date</TableHeaderColumn> TODO: waiting for API return the due date for the rent */}
                    </BootstrapTable>
                ) : (
                    <p>No late payments.</p>
                )}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// app/components/Billing/LatePaymentsList.jsx